import { isValidPhoneNumber } from "../../helpers/validation";

export function isEthernetPurchaseArgValid(key, value) {
  if (key.indexOf("contact_phone") >= 0) {
    return isValidPhoneNumber(value);
  }

  if (key.indexOf("mounting_type") >= 0) {
    return !!value;
  }

  if (key.indexOf("customer_required_date") >= 0) {
    return !!value;
  }

  if (value === "") {
    // this case covers user configurable text fields on the ethernet order form
    return false;
  }

  return true;
}
